import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../auth/context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const getDisplayName = (user) => {
    const fullName = user?.full_name && user.full_name !== 'D2D Customer'
      ? user.full_name
      : user?.email || 'there';
    return fullName.split(' ')[0];
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome back, ${getDisplayName(user)}!`);
      navigate(user.role === 'admin' ? '/admin' : user.onboarding_completed ? '/home' : '/welcome');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-intro">
          <p className="auth-kicker">D2D Shipping Platform</p>
          <h1>Access your customer or operations workspace.</h1>
          <p>
            Sign in to track shipments, review payments, manage manifests, and work from the same
            shipping system used across the platform.
          </p>
        </div>

        <div className="auth-card">
          <div className="auth-card-header">
            <div className="logo">D2D<span>SHIPPING PLATFORM</span></div>
            <p>Sign in to continue</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Email Address</label>
              <input className="input-field" type="email" placeholder="you@example.com" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} required />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input className="input-field" type="password" placeholder="Enter your password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} required />
            </div>
            <div className="auth-inline-link">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? <span className="spinner" /> : 'Sign In'}
            </button>
          </form>

          <div className="auth-link-row">
            <p>Do not have an account? <Link to="/register">Create one</Link></p>
            <p><Link to="/">Back to home</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}
